import React, { useState, useContext } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/Ngo/controlpanelCSS/NgoAuth.css';

import ForgotPassword from '../../../screens/Ngo/auth/ForgetPassword';

import AppContext from '../../../context/AppContext';


function NgoAuth({ onClose }) {
    const navigate = useNavigate();
    const [isLogin, setIsLogin] = useState(true);

    const [showForgot, setShowForgot] = useState(false);

    const { regExpChecker } = useContext(AppContext);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [fullName, setFullName] = useState("");

    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [fullNameError, setFullNameError] = useState("");


    const toggleMode = () => setIsLogin(!isLogin);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isLogin) {
            alert("Login Successful! Welcome to Student Support Hub.");
            onClose?.();
            navigate("/ngo/dashboard");
        } else {
            alert("Registration Successful! Please Login.");
            setIsLogin(true);
        }
    };

    if (showForgot) {
        return <ForgotPassword onBack={() => setShowForgot(false)} />;
    }

    return (
        <div className="ngo-auth-wrapper">
            <div className="ngo-auth-card">

                {/* LEFT PANEL */}
                <div className="ngo-auth-left-panel">
                    <div className="ngo-auth-overlay">
                        <div className="ngo-auth-brand-content">
                            <h1>Student Support Hub</h1>
                            <p>Empowering your educational journey with resources and guidance.</p>
                        </div>
                    </div>
                </div>

                {/* RIGHT PANEL */}
                <div className="ngo-auth-right-panel ngo-auth-fade-in">
                    {isLogin ? (
                        <div>
                            <div className="ngo-auth-form-header">
                                <h2>Welcome Back!</h2>
                                <p className="ngo-auth-subtitle">Please login to your account</p>
                            </div>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control type="email" placeholder="name@example.com"
                                        value={email}
                                        onChange={(event) => {
                                            setEmail(event.target.value);
                                            setEmailError(regExpChecker("email", event.target.value));
                                        }}
                                        required />
                                    <p style={{ color: "red" }}>{emailError}</p>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type="password" placeholder="Enter your password"
                                        value={password}
                                        onChange={(event) => {
                                            setPassword(event.target.value)
                                            setPasswordError(regExpChecker("password", event.target.value));
                                        }}
                                        required />
                                         <p style={{ color: "red" }}>{passwordError}</p>
                                </Form.Group>

                                <div className="text-end mb-3">
                                    <span
                                        className="forgot-link"
                                        onClick={() => setShowForgot(true)}
                                    >
                                        Forgot Password?
                                    </span>
                                </div>

                                <Button type="submit" className="w-100 ngo-auth-btn-primary">
                                    Sign In
                                </Button>
                            </Form>
                            <div className="ngo-auth-switch-text">
                                Don't have an account? <a onClick={toggleMode}>Register here</a>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="ngo-auth-form-header">
                                <h2>Create Account</h2>
                                <p className="ngo-auth-subtitle">Join Student Support Hub today</p>
                            </div>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Full Name</Form.Label>
                                    <Form.Control type="text" placeholder="John Doe" 
                                     value={fullName}
                                        onChange={(event) => {
                                            setFullName(event.target.value);
                                             setFullNameError(regExpChecker("username", event.target.value));
                                        }}
                                    required />
                                     <p style={{ color: "red" }}>{fullNameError}</p>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control type="email" placeholder="name@example.com" 
                                  value={email}
                                        onChange={(event) => {
                                            setEmail(event.target.value);
                                            setEmailError(regExpChecker("email", event.target.value));
                                        }}
                                    required />
                                      <p style={{ color: "red" }}>{emailError}</p>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type="password" placeholder="Create a password"
                                     value={password}
                                        onChange={(event) => {
                                            setPassword(event.target.value)
                                            setPasswordError(regExpChecker("password", event.target.value));
                                        }}
                                    required />
                                       <p style={{ color: "red" }}>{passwordError}</p>
                                </Form.Group>

                                <Button type="submit" className="w-100 ngo-auth-btn-primary">
                                    Sign Up
                                </Button>
                            </Form>
                            <div className="ngo-auth-switch-text">
                                Already have an account? <a onClick={toggleMode}>Login here</a>
                            </div>
                        </div>
                    )}
                </div>

            </div>
        </div>
    );
}

export default NgoAuth;